import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userData")) || null;
    } catch {
      return null;
    }
  });

  // Inicializo desde localStorage al montar
  /* useEffect(() => {
    try {
      const storedUser = localStorage.getItem("userData");
      if (storedUser) {
        setUserData(JSON.parse(storedUser));
      }
    } catch {
      setUserData(null);
    }
  }, []); */

  const login = (user) => {
    localStorage.setItem("userData", JSON.stringify(user));
    setUserData(user);
  };

  const logout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setUserData(null);
  };

  /* const hasPermission = (viewName, action) => {
    if (!userData?.roles) return false;
    const normalizedView = viewName.toLowerCase().trim();
    return userData.roles.some(role =>
      role.permissions?.some(permission =>
        permission.view?.frontend_view?.toLowerCase().trim() === normalizedView &&
        permission[action] === true
      )
    );
  }; */

  const hasPermission = (viewName, action, areaId = null) => {
    if (!userData?.roles) return false;
    const normalizedView = viewName.toLowerCase().trim();

    return userData.roles.some(role =>
      role.permissions?.some(permission =>
        permission.view?.frontend_view?.toLowerCase().trim() === normalizedView &&
        permission[action] === true &&
        (areaId ? permission.area?.id === areaId : true)
      )
    );
  };

  return (
    <AuthContext.Provider value={{ userData, hasPermission, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);